import Text from "components/Text";
import { TEXT_STRING } from "../../constants";

function SessionExpired() {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100">
      {/* Error Icon */}
      <div className="w-24 h-24 rounded-full bg-gray-600 flex items-center justify-center mb-8">
        <svg
          className="w-12 h-12 text-white"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </div>

      {/* Error Message */}
      <div className="text-center space-y-2">
        <Text
          fontSize={18}
          bold
          textColor="text-gray-800"
          center
          className="block"
        >
          {TEXT_STRING.COMMON.SESSION_EXPIRED_TITLE}
        </Text>
        <Text
          fontSize={14}
          textColor="text-gray-600"
          center
          className="block"
        >
          {TEXT_STRING.COMMON.SESSION_EXPIRED_MESSAGE}
        </Text>
      </div>
    </div>
  );
}

export default SessionExpired;
